<!--  -->
<template>
  <div class="footer">
    <el-pagination
      class="my-pagination"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :page-size="pageSize"
      :current-page="currentPage"
      layout="total,prev, pager, next, jumper"
      prev-click
      next-click
      :total="count"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page:0,
      pageSize: 10,
      offset: 0,
    };
  },
  props: ['count','pageList','currentPage'],
  name: '',
  components: {},
  computed: {},
  mounted() {},
  methods: {
    handleCurrentChange(value) {
      this.$emit('currentChange', value);
    },
    handleSizeChange(value) {
      this.$emit('offset', value);
    }
  }
};
</script>
<style lang="scss" scoped>
.footer {
  padding: 10px 0 30px 0;
}

.my-pagination {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examNew/components/pagination.vue